export default __webpack_public_path__ + "static/media/icon_contact.05ed5685.svg";